/* eslint-disable react/react-in-jsx-scope */
import { Skeleton } from "@/components/ui/skeleton";
import { ChevronLeft, ChevronRight } from "lucide-react";

const ReportingSkeleton = () => {
  return (
    <div>
      <div className="flex flex-row gap-4 justify-end items-center">
        <div className="flex py-3">
          <ChevronLeft className="text-foreground/70" />
          <ChevronRight className="text-foreground/70" />
        </div>
        <Skeleton className="w-[100px] h-4 rounded-[20px]" />
      </div>
      <div className="grid grid-cols-2 gap-4">
        <ChartSkeleton />
        <ChartSkeleton />
      </div>
    </div>
  );
};
export const ChartSkeleton = () => {
  return (
    <>
      <div className="mb-4 basis-1/2 h-[400px] bg-[#F7F9FB] rounded-[20px]">
        <div className="flex flex-row items-center justify-start mx-5">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#bdbebf"
            strokeWidth="1.75"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-chevron-down-icon lucide-chevron-down"
          >
            <path d="m6 9 6 6 6-6" />
          </svg>
          <Skeleton className="rounded-full w-[150px] h-5 m-5 bg-[#ecedee]" />
        </div>
        <div className="grid grid-cols-2">
          <div className="flex flex-col justify-between">
            <Skeleton className="rounded-full w-[50px] h-3 m-5 bg-[#ecedee]" />
            <Skeleton className="rounded-full w-[50px] h-3 m-5 bg-[#ecedee]" />
            <Skeleton className="rounded-full w-[50px] h-3 m-5 bg-[#ecedee]" />
          </div>
          <div>
            <div className="flex flex-row gap-16  items-end justify-end mx-5">
              <Skeleton className="rounded-full w-[25px] h-[100px] bg-[#ecedee]" />
              <Skeleton className="rounded-full w-[25px] h-[200px] bg-[#ecedee]" />
              <Skeleton className="rounded-full w-[25px] h-[275px] bg-[#ecedee]" />
              <Skeleton className="rounded-full w-[25px] h-[250px] bg-[#ecedee]" />
            </div>
          </div>
        </div>
        <div className="flex flex-row justify-between">
          {Array.from({ length: 7 }).map((i, k) => (
            <Skeleton
              className="rounded-full w-[50px] h-3 m-5 bg-[#ecedee]"
              key={k}
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default ReportingSkeleton;
